const toc = document.querySelector('.toc');
if (toc) {
    const navigationLinks = toc.querySelectorAll('.toc__navigation a');
    [...navigationLinks].forEach((linkEl) => {
        linkEl.addEventListener('click', (e) => {
            e.preventDefault();

            const yOffset = -100;
            const elementToScrollIntoView = document.querySelector(linkEl.getAttribute('href'));

            const y = elementToScrollIntoView.getBoundingClientRect().top + window.pageYOffset + yOffset;

            window.scrollTo({ top: y, behavior: 'smooth' });

            toc.removeAttribute('open');
        });
    });
}
